<app-shared-dialog class="technical_dialog" [title]="'inventory.edit_technical.title' | translate" 
    [options]="{
        titleIcon: 'pen-cc',
        titleIconColor: 'primary',
        confirmText: 'inventory.product_edit_pricing.save' | translate,
        cancelText: 'inventory.product_edit_pricing.cancel' | translate,
        confirmButtonStyle: 'primary-btn',
        customConfirmButton: true
    }" (cancel)="cancel()">
    <div class="section gray-section" *ngIf="isVariantProduct() && data.attributes && data.attributes.length > 0">
        <div class="section-header">
            <span>{{"inventory.product_details.variant_selection" | translate}}</span>
        </div>
        <div class="info-list">
            <div class="info-row" *ngFor="let attr of data.attributes">
                <span class="label">{{attr.name}}</span>
                <div class="info-row">
                <span *ngFor="let value of attr.values" class="badge white" (click)="selectAttributeValue(attr.name, value)" [class.selected]="isSelected(attr.name, value)">{{value}}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="technical_container" [formGroup]="form">
        <ckeditor [editor]="Editor" formControlName="technical_details" [config]="editorConfig"></ckeditor>
    </div>
    <ui-button
      customConfirm
      *appHasPermission="{ module: 'product', action: 'edit' }"
      type="primary"
      [label]="'inventory.product_edit_pricing.save' | translate"
      (click)="save()">
    </ui-button>
</app-shared-dialog>
